import { Pill, type PillVariant } from '../../../ds/components';
import type { StageView, Tone } from '../types';

/** A2 tone pairs: Unterlagen sand-200, Angefragt/Angebote info, Zusage accent, Unterschrieben/Ausgezahlt success, Verloren danger. */
const variants: Record<Tone, PillVariant> = {
  neutral: 'neutral',
  info: 'info',
  accent: 'accent',
  success: 'success',
  danger: 'danger',
};

export interface StagePillProps {
  stage: Pick<StageView, 'label' | 'tone'>;
  className?: string | undefined;
}

/** The stage pill of lists, boards and records (label as the API sends it, colour from its tone). */
export function StagePill({ stage, className }: StagePillProps) {
  return (
    <Pill variant={variants[stage.tone]} className={className}>
      {stage.label}
    </Pill>
  );
}
